<script setup>
import { ref, computed } from 'vue'
import Width from "@/pages/Index/Width.vue";
import { useStore } from "vuex";
import {useRouter} from "vue-router";
import MobileFooter from "@/components/Footer/MobileFooter.vue";

const router = useRouter()

const store = useStore()

const currentLang = computed(() => store.getters.currentLanguage)

const list = computed(() => {
	return [
		{
			title: 'footer.blockTitles.about',
			blocks: [
				{
					title: 'footer.home',
					path: '/'
				},
				{
					title: 'footer.news',
					path: '/newsInformation'
				},
				{
					title: 'footer.contact',
					path: '/contactus'
				},
			]
		},
		{
			title: 'footer.blockTitles.moldManufacturing',
			blocks: [
				{
					title: 'footer.power',
					path: '/manufacture'
				},
				{
					title: 'footer.customerCase',
					path: '/customer-case'
				},
				{
					title: 'footer.product',
					path: '/productDisplay'
				}
			]
		},
		{
			title: 'footer.blockTitles.friendlyLinks',
			blocks: [
				{
					title: 'footer.moldCloud',
					path: 'https://www.mouldc.com/'
				}
			]
		}
	]
})

const info = computed(() => {
	return [
		{
			icon: 'phone',
			label: 'footer.phone',
			value: store.state.companyInfo?.contact_phone
		},
		{
			icon: 'fax',
			label: 'footer.fax',
			value: store.state.companyInfo?.facsimile
		},
		{
			icon: 'internet',
			label: 'footer.website',
			value: ''
		}
	]
})

const getQrCodeInfo = computed(() => {
	const info = store.state.companyInfo
	return [
		{
			title: info?.[`left_title_${currentLang.value}`],
			img: info?.[`left_image_${currentLang.value}`]
		},
		{
			title: info?.[`right_title_${currentLang.value}`],
			img: info?.[`right_image_${currentLang.value}`]
		}
		// {
		// 	title: info?.[`right_title_most_${currentLang.value}`],
		// 	img: info?.[`right_image_most_${currentLang.value}`]
		// }
	]
})

const recordNumber = computed(() => store.state.companyInfo?.record_number)

const handleToPage = (path) => {
	const httpPrefixReg = /https{0,1}:\/\//
	if(httpPrefixReg.test(path)){
		window.open(path)
	}else{
		toPage(path)
	}
}

function toPage(path){
	router.push(path)
	window.scrollTo({
		top: 0,
		left: 0,
		behavior: 'smooth'
	})
}

</script>

<template>
	<MobileFooter
		class="mobile-footer"
	/>
	<div class="footer">
		<Width>
			<div class="footer__footer">
				<div class="footer__footer__top">
					<div class="left">
						<div class="left__logo">
							<SvgIcon name="logo" class-name="icon" />
						</div>
						
						<div class="left__info">
							<div
								class="row"
								v-for="(info, index) in info"
								:key="index"
							>
								<div class="row__icon">
									<SvgIcon :name="info.icon" class-name="row__icon__icon" />
								</div>
								
								<div class="row__value">
									{{ $t(info.label) }}{{ info.value }}
								</div>
							</div>
						</div>
					</div>
					
					<div class="center">
						<div
							class="center__block"
							v-for="(block, bIndex) in list"
							:key="bIndex"
						>
							<div class="center__block__title">{{ $t(block.title) }}</div>
							<div class="center__block__menu">
								<div
									class="menu__item"
									v-for="(menu, mIndex) in block.blocks"
									:key="mIndex"
									@click="handleToPage(menu.path)"
								>
									{{ $t(menu.title) }}
								</div>
							</div>
						</div>
					</div>
					
					<div class="right">
						<div
							v-for="(img, mIndex) in getQrCodeInfo"
							:key="mIndex"
							class="right__qrcode"
						>
							<div class="right__qrcode__img">
								<el-image
									:src="img.img"
									style="width: 100%;height: 100%"
									fit="cover"
								/>
							</div>
							
							<div class="right__qrcode__title">{{ img.title }}</div>
						</div>
					</div>
				</div>
				
				<div class="footer__footer__bottom">
					<div>
						<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" class="link">
							{{ $t('footer.record') }}{{ recordNumber }}
						</a>
					</div>
					<span class="sep">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
					<div>{{ $t('footer.copyright') }}</div>
					<span class="sep">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
					<div>
						<a
							target="_blank"
							href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33020702000029"
							class="link"
						>
							浙公网安备 33020702000029号
						</a>
					
					</div>
				</div>
			</div>
		</Width>
	</div>
</template>

<style scoped lang="less">
.mobile-footer {
	display: none;
}

.footer {
	background: #2F3030;
	padding: 70px 0 0 0;
	
	&__footer {
		
		&__top {
			display: flex;
			justify-content: space-between;
			
			.left {
				width: 25%;
				&__logo {
					margin-bottom: 30px;
				}
				
				&__info {
					.row {
						display: flex;
						align-items: center;
						margin-bottom: 20px;
						
						&:last-child {
							margin-bottom: 0;
						}
						
						&__icon {
							margin-right: 16px;
							
							&__icon {
								width: 16px;
								height: 16px;
							}
						}
						
						&__value {
							font-size: 16px;
							color: rgba(255, 255, 255, .5);
						}
					}
				}
				
			}
			
			.center {
				display: flex;
				justify-content: space-around;
				width: 45%;
				
				&__block {
					
					&__title {
						color: #fff;
						font-size: 20px;
						font-weight: bold;
						margin-bottom: 30px;
					}
					
					&__menu {
						color: rgba(255, 255, 255, 0.5);
						
						.menu__item {
							margin-bottom: 20px;
							cursor: pointer;
							
							&:last-child {
								margin-bottom: 0;
							}
						}
					}
				}
			}
			
			.right {
				width: 25%;
				display: flex;
				justify-content: space-between;
				&__qrcode {
					width: calc(100% / 2);
					margin-right: 15px;
					color: rgba(255, 255, 255, 0.5);
					display: flex;
					flex-direction: column;
					//justify-content: space-between;
					align-items: center;
					
					&:last-child {
						margin-right: 0;
					}
					
					&__img {
						width: 90px;
						height: 90px;
					}
					
					&__title {
						text-align: center;
						margin-top: 20px;
					}
				}
				
				
			}
		}
		
		&__bottom {
			color: rgba(255, 255, 255, .5);
			font-size: 16px;
			margin-top: 54px;
			border-top: 0.5px solid #E4E7ED;
			padding: 20px 0;
			display: flex;
			justify-content: center;
			align-items: center;
			
			.link {
				color: rgba(255, 255, 255, .5) !important;
			}
		}
	}
	
	.icon {
		width: 222px;
		height: 32px;
	}
}

@media only screen and (max-width: 1200px) {

	.footer {
		padding: 30px 0 0 0;
		&__footer {

			&__top {
				.left {
					width: auto;

					&__info {
						.row {
							&__value {
								font-size: 12px;
							}
						}
					}
				}
				.right {

					&__qrcode {

						&__img {
							width: 90px;
							height: 90px;
						}

						&__title {
							text-align: center;
							margin-top: 10px;
							font-size: 12px;
						}
					}
				}
			}

		}
	}
}

@media only screen and (max-width: 1024px) {
	.mobile-footer {
		display: block !important;
	}
	
	.footer {
		padding: 0;
		display: none;
	}
}

@media only screen and (max-width: 768px) {
	.footer {
		&__footer {
			
			&__top {
				flex-direction: column;
		
				.right {
					margin-top: 20px;
					
					&__qrcode {
						margin-right: 0;
						&__img {
							width: 90px;
							height: 90px;
						}
						
						&__title {
							text-align: center;
							margin-top: 10px;
							font-size: 12px;
						}
					}
				}
			}
			
			&__bottom {
				margin-top: 20px;
				flex-direction: column;
				font-size: 12px;
				> div {
					margin-bottom: 10px;
					
					&:last-child {
						margin-bottom: 0;
					}
				}
				.sep {
					display: none;
				}
			}
			
		}
	}
}
</style>